module.exports = __webpack_public_path__ + "assets/img/06.e712991e.png";